import store from "@/store";
import l10n from "@/services/l10n";
import createPlaylist from "./createPlaylist";

import { USER_GROUP_PERSON } from "@/constants";

export default ({ tracks, single = false, active = true }) => {
  const getPlaylists = function() {
    return store.getters["playlists/playlistsArray"];
  };

  const getPaylistAction = function({ id, title, tracks }) {
    return {
      active: true,
      authModal: true,
      title,
      icon: "add",
      accessLevel: [USER_GROUP_PERSON],
      action() {
        store.dispatch("playlists/addTracks", {
          playlistId: id,
          tracksIds: tracks
        });
      }
    };
  };

  const subitems = [
    ...getPlaylists().map(playlist =>
      getPaylistAction({ id: playlist.id, title: playlist.title, tracks })
    ),
    createPlaylist({ tracks })
  ];

  return single
    ? subitems
    : {
        active,
        authModal: true,
        title: l10n("ADD_TO_PLAYLIST"),
        icon: "add",
        accessLevel: [USER_GROUP_PERSON],
        subitems
      };
};
